import React, { useState, useEffect } from 'react'
import useDistanceList from '../dashboard/DistanceList'
import Settings from './Settings'

function NewSettings() {

let distance = useDistanceList(false);

	return(
		<Settings/>
	);
}

export default NewSettings;